<box>
  <div class="box-header">
    <div class="box-header__title">Parfait !</div>
    <div class="box-header__description">
      Nous avons déterminé votre profil investisseur.
    </div>
  </div>
  <box-number> {{ riskStatus }} </box-number>

  <box-footer>
    <div class="mt-1">
      @if (!toggle) {
        <span class="footer-text" (click)="readMore()"> Voir le résumé</span>
      }
      @if (toggle) {
        <div>
          <profile-summary></profile-summary>
        </div>
      }

      @if (toggle) {
        <span class="footer-text" (click)="readMore()"> Réduire le résumé</span>
      }
    </div>
  </box-footer>
</box>
